module.exports = __webpack_public_path__ + "static/CheckIcon-9148158830e6a69505de6781ad2d663d.svg";